export const USER_TOKEN = 'userToken';
export const SUPERADMIN_TOKEN = 'superadminToken';
export const TEACHER_TOKEN = 'teacherToken';
export const ADMIN_TOKEN = 'adminToken';
export const MANAGER_TOKEN = 'managerToken';
export const SUPPORT_TOKEN = 'supportToken';
